import { Space, Typography } from 'antd'
import { useProjectSettingsContext } from '../../../../../../ProjectSettingsContext'
import CIMSBasicFields from 'components/CIMSBasicFields'
import { HelpMessage } from 'utils/constants'
import { IFIReportType } from '@cims-online/shared'
import CIMSCollapse from 'components/CIMSCollapse'
import EnabledIndicator from '../../../../components/EnabledIndicator'
import { dateFormatter } from 'utils/dateFormatter'

const Help = HelpMessage.Administration.ProjectSettings.IFITracker
const {
  id: reportId,
  defaultMessages: { missing },
} = IFIReportType.DailyInspectionInspection

const InspectionViewPanel: React.VFC = () => {
  const {
    inspectionIFISettings: { data },
  } = useProjectSettingsContext()

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Typography>
        If Unresolved Issues Associated with this Work is set to Yes, issue an
        Identified Field Issue using the NCR Issue Description.
      </Typography>
      <CIMSBasicFields
        fields={[
          {
            label: 'Effective Date',
            help: Help.EffectiveDate,
            children: dateFormatter.simple(data?.effectiveDate),
          },
        ]}
      />
      <CIMSCollapse
        panels={[
          {
            header: {
              children: 'Missing Geometry',
            },
            key: `view-missing-geometry-${reportId}`,
            extra: {
              children: (
                <EnabledIndicator enabled={data?.missingGeometry?.enabled} />
              ),
            },
            children: (
              <Space direction="vertical" size="middle">
                <Typography>
                  If the Inspection is missing geometry and its Review Status is
                  "Submitted", "Approved", or "Denied", issue an Identified
                  Field Issue using the Message. This may issue an Identified
                  Field Issue for an Inspection without Unresolved Issues.
                </Typography>
                <CIMSBasicFields
                  fields={[
                    {
                      label: 'Message',
                      help: Help.FailureMessage(),
                      children: data?.missingGeometry?.message ?? missing,
                    },
                  ]}
                />
              </Space>
            ),
          },
        ]}
      />
    </Space>
  )
}

export default InspectionViewPanel
